export const tlsAccTooltip = '状态变更时，会重启Pod，请注意后续的流量情况';
